module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-page-flat-lay-placeholder-ede97e3ac58b3380fb49b00d40bd02b4.jpg";